export const initialState = {
  types: [],
  audience: "pride",
  flags: [],
  showAllFilters: true,
}

export function filtersReducer(state, action) {
  switch (action.type) {
    case "changed_filter": {
      return {
        ...state,
        [action.filterType]: action.value,
      }
    }
    case "clear_filters": {
      return {
        ...state,
        types: [],
        flags: [],
        audience: "pride",
      }
    }
    case "toggle_show_filters": {
      return {
        ...state,
        showAllFilters: !state.showAllFilters,
      }
    }
    default: {
      throw Error("Unknown action: " + action.type)
    }
  }
}
